import { Translate } from '~/i18n';
import { ShareIcon } from '~/svgs/common';
import { useState, Fragment } from 'react';
import dynamic from 'next/dynamic';
const AboutModal = dynamic(() => import('./modal'), { ssr: false });

type AboutTopProps = {
   share_title: any;
   share_description: any;
   classname?: string;
};

const AboutTop = ({ share_title, share_description, classname }: AboutTopProps) => {
   const [sharing, setShare] = useState(false);

   const share = () => {
      if (navigator.share) {
         navigator.share({
            url: window.location.href,
            title: share_title,
            text: share_description,
         });
      } else {
         setShare(true);
      }
   };

   const stopSharing = () => setShare(false);

   return (
      <Fragment>
         <button
            onClick={share}
            className={
               classname
                  ? classname
                  : 'hidden px-3 py-1 text-sm rounded-full text-primary-light hover:bg-primary-disabled ltr:-mr-3 rtl:-ml-3 tablet:block'
            }>
            <span className="flex items-center">
               <ShareIcon className="-mt-1" />
               <span className="block ltr:ml-2 rtl:mr-2">
                  <Translate id="common:share" />
               </span>
            </span>
         </button>
         <AboutModal
            sharing={sharing}
            share_description={share_description}
            share_title={share_title}
            stopSharing={stopSharing}
         />
      </Fragment>
   );
};

export default AboutTop;
